import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EnvironmentConfig} from '@environments/environment';
import {SamlLoginComponent} from '@components/user/saml-login/saml-login.component';
import {AgreementComponent} from '@components/user/agreement/agreement.component';
import {LoginComponent} from '@components/user/login/login.component';
import {EditProfileComponent} from '@components/user/edit-profile/edit-profile.component';
import {AuthorizationGuardService} from './shared/authorization-guard/authorization-guard.service';
import {PasswordResetComponent} from '@components/user/password-reset/password-reset.component';

const routes: Routes = [
 
];

if (EnvironmentConfig.PortalSettings.ssoEnabled) {
  routes.push({path: '', redirectTo: '/samllogin', pathMatch: 'full'});
  routes.push({path: 'samllogin', component: SamlLoginComponent});
  routes.push({path: 'agreement', component: AgreementComponent});

}
if (EnvironmentConfig.PortalSettings.loginPageEnabled) {
  routes.push({path: '', redirectTo: '/dashboard', pathMatch: 'full'});
  routes.push({path: 'login', component: LoginComponent});
  routes.push({path: 'agreement', component: AgreementComponent});

}

routes.push({path: 'profile', component: EditProfileComponent, canActivate: [AuthorizationGuardService]});
routes.push( {
    path: 'authorization',
    children: [
      {
        path: 'resetPassword',
        children:[
          {
            path:'**',
            component: PasswordResetComponent
          }
        ]
      }]
  });

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
